const MODULES = [
  {
    path: './hero.js',
    exportName: 'initHero',
    selector: '[data-section-type="hero"]',
  },
  {
    path: './header.js',
    exportName: 'initHeader',
    selector: '[data-section-type="header"]',
  },
  {
    path: './collection.js',
    exportName: 'initCollection',
    selector: '[data-section-type="collection"]',
  },
  {
    path: './product.js',
    exportName: 'initProduct',
    selector: '[data-section-type="product"]',
  },
  {
    path: './cart.js',
    exportName: 'initCart',
    selector: '[data-cart-drawer]',
  },
  {
    path: './slideshow.js',
    exportName: 'initSlideshow',
    selector: '[data-section-type="slideshow"]',
  },
  {
    path: './featured-products.js',
    exportName: 'initFeaturedProducts',
    selector: '[data-section-type="featured-products"]',
  },
  {
    path: './video-banner.js',
    exportName: 'initVideoBanner',
    selector: '[data-video-banner]',
  },
  {
    path: './footer.js',
    exportName: 'initFooter',
    selector: '[data-section-type="footer"]',
  },
  {
    path: './home.js',
    exportName: 'initHome',
    selector: '.template-index',
  },
];

const SCROLL_ANIMATION_MODULES = [
  {
    path: './animations.js',
    exportName: 'initAnimations',
    selector: '[data-animate], [data-scroll-section]',
  },
];

function usesSmoothScrollRuntime() {
  return Boolean(
    window.__SMOOTH_SCROLL_INIT_STARTED ||
      window.__SMOOTH_SCROLL_BOOTED ||
      document.querySelector('script[src*="sf-scroll.js"]') ||
        document.querySelector('script[src*="smooth-scroll.js"]')
  );
}

async function initModule(module) {
  if (usesSmoothScrollRuntime() && module.path === './hero.js') {
    return;
  }

  if (module.selector && !document.querySelector(module.selector)) {
    return;
  }

  try {
    const loadedModule = await import(module.path);
    const init = loadedModule[module.exportName];

    if (typeof init === 'function') {
      await init();
    }
  } catch {
    return;
  }
}

async function initLenisFirst(retriesLeft = 40) {
  if (usesSmoothScrollRuntime()) {
    return;
  }

  try {
    const { initLenis } = await import('./lenis.js');
    const instance = initLenis();

    if (!instance && typeof Lenis === 'undefined' && retriesLeft > 0) {
      await new Promise((resolve) => requestAnimationFrame(resolve));
      return initLenisFirst(retriesLeft - 1);
    }
  } catch {
    return;
  }
}

function getModules() {
  if (document.body.hasAttribute('data-native-scroll')) {
    return MODULES;
  }

  return [...SCROLL_ANIMATION_MODULES, ...MODULES];
}

export async function initApp() {
  await initLenisFirst();
  return Promise.all(getModules().map(initModule));
}

function bootApp() {
  document.documentElement.classList.replace('no-js', 'js');
  initApp();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootApp);
} else {
  bootApp();
}
